module.exports = __webpack_public_path__ + "img/10-half-sm.6b52308b.jpg";